import { Card, Col, Row } from 'react-bootstrap';
import './professionalMembershipContent.css';

const ProfessionalMembershipContent = ({ professionalReferences, professionalMemberships }) => {
  const isEmpty = (arr) => !arr || arr.length === 0;

  return (
    <div className="membership-container">
      {/* Professional References Section */}
      <div className="membership-card">
        <Card>
          <Card.Body className={`professionalMembershipPanel pd-1 ${isEmpty(professionalReferences) ? 'no-data' : ''}`}>
            <h5 className="professionalMembershipTitle">Professional Reference</h5>
            {professionalReferences && professionalReferences.length > 0 ? (
              professionalReferences.map((reference, index) => (
                <div key={index}>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Name</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.name || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Organisation</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.organisation || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Mobile Number</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.phoneNumber || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Designation</Col>
                    <Col className="professionalMembershipValue mt-3">{reference.designation || '-'}</Col>
                  </Row>
                  {professionalReferences.length > 1 && index !== professionalReferences.length - 1 && <hr />}

                </div>
              ))
            ) : (
              <div className="noContentMessage"></div>

            )}
          </Card.Body>
        </Card>
      </div>

      {/* Professional Memberships Section */}
      <div className="membership-card">
        <Card>
          <Card.Body className={`professionalMembershipPanel pd-1 ${isEmpty(professionalMemberships) ? 'no-data' : ''}`}>
            <h5 className="professionalMembershipTitle">Professional Membership</h5>
            {professionalMemberships && professionalMemberships.length > 0 ? (
              professionalMemberships.map((membership, index) => (
                <div key={index}>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Name</Col>
                    <Col className="professionalMembershipValue mt-3">{membership.name || '-'}</Col>
                  </Row>
                  <Row>
                    <Col className="professionalMembershipSubTitle mt-3">Member Since</Col>
                    <Col className="professionalMembershipValue mt-3">{membership.year || '-'}</Col>
                  </Row>
                  {professionalMemberships.length > 1 && index !== professionalMemberships.length - 1 && <hr />}

                </div>
              ))
            ) : (
              <div className="noContentMessage"></div>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default ProfessionalMembershipContent;